var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["category/templates/empty/category-empty-brands.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"o-row o-column o-extra-small--12 u-centered-content c-brand-no-results\">";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"))) {
var t_1;
t_1 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"flatNavigation")),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug"))),"displayName");
frame.set("title", t_1, true);
if(frame.topLevel) {
context.setVariable("title", t_1);
}
if(frame.topLevel) {
context.addExport("title", t_1);
}
;
}
else {
var t_2;
t_2 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "category")),"categorySlug");
frame.set("title", t_2, true);
if(frame.topLevel) {
context.setVariable("title", t_2);
}
if(frame.topLevel) {
context.addExport("title", t_2);
}
;
}
output += "<h1 class=\"c-brand-no-results__h1\">\n        ";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "title"), env.opts.autoescape);
output += "\n    </h1>\n\n    <h2 class=\"c-brand-no-results__h2\">\n        ";
output += runtime.suppressValue((lineno = 15, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["category_brands_not-found-no-results",runtime.makeKeywordArgs({"params": [runtime.contextOrFrameLookup(context, frame, "title")]})])), env.opts.autoescape);
output += "\n    </h2>\n\n    <p class=\"c-brand-no-results__p\">\n\n        ";
output += runtime.suppressValue(env.getFilter("markdown_nowrap").call(context, (lineno = 20, colno = 10, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["brands_all-brands-link"]))), env.opts.autoescape);
output += "\n\n    </p>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["category/templates/empty/category-empty-brands.j2"] , dependencies)